var React = require('react');

function CloseModal (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21","cy":"21","r":"21","fill":"white","fillOpacity":"0.5","key":0}),React.createElement("line",{"x1":"13.8284","y1":"15","x2":"27.9706","y2":"29.1421","stroke":"white","strokeWidth":"4","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"14","y1":"29.1716","x2":"28.1421","y2":"15.0294","stroke":"white","strokeWidth":"4","strokeLinecap":"round","key":2})]);
}

CloseModal.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = CloseModal;

CloseModal.default = CloseModal;
